import React, { useEffect, useState } from 'react';
import BossDialog from '../../components/BossDialog';
import { EditPageHeader } from '../../components/EditPageHeader';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { useTranslation } from '../../locale/useTranslation';
import { utility } from '../../framework/utility/utilityProvider';
import { ADS_TYPE, ENTITYNAME } from '../../framework/constant/constant';
import * as API from '../../framework/API/api';
import { toast } from 'react-toastify';
import { Grid, GridColumn as GridColumn } from "@progress/kendo-react-grid";
import moment from 'moment';
import { META_STATUS_TYPE } from './SocialMediaConstant';
import AddRoundButton from '../../framework/forms/helpercomponents/buttons/AddRoundButton';
import SMAdsetForm from './SMAdsetForm';
import MetaCampaignEditForm from './Meta/MetaCampaignEditForm';
import PublishOrUnPublishStatusCard from './PublishOrUnPublishStatusCard';
import { DateTimeCell } from '../../framework/forms/helpercomponents/CustomGridCells/DateCell';
import GoogleCampaignForm from './Google/GoogleCampaignForm';
import { MenuCommandCell } from '../../framework/forms/helpercomponents/CustomGridCells/MenuCommandCell ';
import LinkedinCampaignForm from './LinkedIn/LinkedinCampaignForm';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';
import CollectionSelection from '../../framework/forms/CollectionSelection';

const SMCampaignCollectionForm = ({ cancelEdit, refresh, item = {}, onSave, campaignData = [] }) => {

    const lang = useTranslation();

    const getFinalData = (value) => {
        switch (value?.channel?.adType) {
            case ADS_TYPE.META:
                return {
                    objective: value?.meta?.objective ? { _id: value?.meta?.objective, description: value?.meta?.objective } : {},
                    buying_type: value?.meta?.buying_type ? { _id: value?.meta?.buying_type, description: value?.meta?.buying_type } : {},
                    bid_strategy: value?.meta?.bid_strategy ? { _id: value?.meta?.bid_strategy, description: value?.meta?.bid_strategy } : {},
                    spend_cap: value?.meta?.spend_cap ?? '',
                    daily_budget: value?.meta?.daily_budget ?? '',
                    special_ad_categories: value?.meta?.special_ad_categories && value?.meta?.special_ad_categories.length > 0 ? value?.meta?.special_ad_categories.map((x) => ({ _id: x, description: x })) : [],
                    metaCampaignId: value?.meta?.metaCampaignId ?? null,
                }
            case ADS_TYPE.GOOGLE:
                return {
                    advertising_channel_type: value?.google?.advertising_channel_type ? { _id: value?.google?.advertising_channel_type, description: value?.google?.advertising_channel_type } : {},
                    cpc_bid_micros: value?.google?.cpc_bid_micros ?? '',
                    googleCampaignId: value?.googleCampaignId ?? null
                }
            case ADS_TYPE.LINKEDIN:
                return {
                    dailyBudget: value?.linkedin?.dailyBudget ?? '',
                    type: value?.linkedin?.type ? { _id: value?.linkedin?.type, description: value?.linkedin?.type } : {},
                }
        }
    }

    const blankDataItem = {
        _id: item?._id ?? null,
        name: item?.name ?? '',
        budget: item?.budget ?? {},
        channel: item?.channel ?? {},
        start_time: item?.start_time ? moment(item?.start_time).format('YYYY-MM-DD HH:mm:ss') : moment().format('YYYY-MM-DD HH:mm:ss'),
        end_time: item?.end_time ? moment(item?.end_time).format('YYYY-MM-DD HH:mm:ss') : moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        ...getFinalData(item),
    }

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [channels, setChannels] = useState([]);
    const [adsetData, setAdsetData] = useState(item?.ad_data ?? []);
    const [showAdsetPopup, setShowAdsetPopup] = useState({ show: false, item: {} });
    const [isLoading, setIsLoading] = useState(false);
    const [openCampaignSelection, setOpenCampaignSelection] = useState(false);
    const [budgetCredit, setBudgetCredit] = useState({});
    const [budgetData, setBudgetData] = useState({});


    useEffect(() => {
        loadCombo();
        if (item?._id) loadData();
    }, [])

    const loadData = async () => {

        const res = await API.getBudgetData(item?.budget?._id);
        console.log(res);

        if (!res.success) {
            toast.error(res.message, { position: toast.POSITION.TOP_RIGHT });
            return;
        }
        setBudgetData(res?.data?.budgetData ?? {});

        const campaignData = res?.data?.campaignData?.find(c => c?._id === item?._id);
        console.log(campaignData)
        setAdsetData(campaignData?.ad_data)

        let response = await API.getAvailableBudget({ _id: dataItem?.budget?._id });
        if (response.success) setBudgetCredit(response.data)
    };

    const loadCombo = async () => {
        let channelRes = await API.getDataLookup(ENTITYNAME.SM_Channels);
        setChannels(channelRes.data);
        if (!item?._id && !item?.index) setDataItem({ ...dataItem, channel: utility.getDefaultItem(channelRes.data) })
    }

    const onChange = (e) => {
        const { name, value } = e.target;
        setDataItem({ ...dataItem, [name]: value });
    };

    // const handleAdsetDelete = (value, index) => {
    //     const updatedAdData = adsetData.filter((x, i) => i !== index);
    //     setAdsetData(updatedAdData);
    // }

    const handleAdsetCreate = (data) => {
        if (data?.index !== undefined) {
            const updatedAdData = adsetData.map((x, i) => {
                if (i === data.index) return data;
                return x;
            });
            setAdsetData(updatedAdData);
        } else {
            setAdsetData([...adsetData, data]);
        }
    }

    // const calculateRemainingSpendCap = () => {
    //     const targetAmount = parseInt(budgetData.targetAmount) || 0;

    //     const getSpendCap = (campaign) => {
    //         const adType = campaign.channel?.adType;
    //         switch (adType) {
    //             case 'META':
    //                 return parseInt(campaign.meta?.spend_cap) || 0;
    //             case 'GOOGLE':
    //                 return parseInt(campaign.google?.cpc_bid_micros) || 0;
    //             default:
    //                 return 0;
    //         }
    //     };

    //     const totalSpendCap = campaignData.reduce((total, campaign) => {
    //         if (item?.index !== undefined && campaign._id === item._id) {
    //             return total;
    //         }
    //         return total + getSpendCap(campaign);
    //     }, 0);

    //     return targetAmount - totalSpendCap;
    // };


    const isValid = () => {
        if (!dataItem.budget || Object.keys(dataItem.budget).length == 0) {
            toast.error(lang.please_select_budget_error_message, {
                position: toast.POSITION.TOP_RIGHT
            })
            return false
        }
        if (!dataItem.name || dataItem.name === "") {
            toast.error(lang.please_enter_name_error_message, {
                position: toast.POSITION.TOP_RIGHT
            })
            return false
        }
        if (!dataItem.channel || Object.keys(dataItem.channel).length == 0) {
            toast.error(lang.please_select_channel_error_message, {
                position: toast.POSITION.TOP_RIGHT
            })
            return false
        }
        if (!dataItem.start_time || dataItem.start_time === "") {
            toast.error(lang.please_enter_start_time_error_message, {
                position: toast.POSITION.TOP_RIGHT
            })
            return false
        }
        if (!dataItem.end_time || dataItem.end_time === "") {
            toast.error(lang.please_enter_end_time_error_message, {
                position: toast.POSITION.TOP_RIGHT
            })
            return false
        }
        if (dataItem.end_time < dataItem.start_time) {
            toast.error(
                <div>
                    <strong>INVALID</strong>
                    <div style={{ fontSize: '13px' }}>{lang.end_time_cannot_be_earlier_than_start_time_message}</div>
                </div>,
                { position: toast.POSITION.TOP_RIGHT }
            );
            return false
        }
        switch (dataItem.channel?.adType) {
            case ADS_TYPE.META:
                if (!dataItem.objective || Object.keys(dataItem.objective).length == 0) {
                    toast.error(lang.please_select_objective_error_message, {
                        position: toast.POSITION.TOP_RIGHT
                    })
                    return false
                }
                if (!dataItem.buying_type || Object.keys(dataItem.buying_type).length == 0) {
                    toast.error(lang.please_select_buying_type_error_message, {
                        position: toast.POSITION.TOP_RIGHT
                    })
                    return false
                }
                if (!dataItem.bid_strategy || Object.keys(dataItem.bid_strategy).length == 0) {
                    toast.error(lang.please_select_bid_strategy_error_message, {
                        position: toast.POSITION.TOP_RIGHT
                    })
                    return false
                }
                if (!dataItem.spend_cap || dataItem.spend_cap === "") {
                    toast.error(lang.please_select_spend_cap_error_message, {
                        position: toast.POSITION.TOP_RIGHT
                    })
                    return false
                }
                // if (parseInt(dataItem.spend_cap) > calculateRemainingSpendCap()) {
                //     toast.error(lang.please_enter_spend_cap_cannot_exceed_available_budget_error_message, {
                //         position: toast.POSITION.TOP_RIGHT
                //     })
                //     return false
                // }
                if (!dataItem.daily_budget || dataItem.daily_budget === "") {
                    toast.error(lang.please_enter_daily_budget_error_message, {
                        position: toast.POSITION.TOP_RIGHT
                    })
                    return false
                }
                if (parseInt(dataItem.daily_budget) > parseInt(dataItem.spend_cap)) {
                    toast.error(
                        <div>
                            <strong>INVALID</strong>
                            <div style={{ fontSize: '13px' }}>{lang.please_enter_daily_budget_cannot_exceed_spend_cap_error_message}</div>
                        </div>,
                        { position: toast.POSITION.TOP_RIGHT }
                    );
                    return false
                }
                break;
            case ADS_TYPE.GOOGLE:
                if (!dataItem?.advertising_channel_type || Object.keys(dataItem?.advertising_channel_type).length == 0) {
                    toast.error(
                        <div>
                            <strong>INVALID</strong>
                            <div style={{ fontSize: '13px' }}>{lang.please_select_advertising_channel_type_error_message}</div>
                        </div>,
                        { position: toast.POSITION.TOP_RIGHT }
                    );
                    return false
                }
                if (!dataItem?.cpc_bid_micros || dataItem?.cpc_bid_micros === 0) {
                    toast.error(lang.please_enter_cpc_bid_micros_error_message, {
                        position: toast.POSITION.TOP_RIGHT
                    })
                    return false
                }
                break;
            case ADS_TYPE.LINKEDIN:
                if (!dataItem?.type || Object.keys(dataItem?.type).length == 0) {
                    toast.error(lang.please_select_linkedin_campaign_type_error_message, {
                        position: toast.POSITION.TOP_RIGHT
                    })
                    return false
                }
                if (!dataItem?.dailyBudget || dataItem?.dailyBudget === 0) {
                    toast.error(lang.please_select_daily_budget_error_message, {
                        position: toast.POSITION.TOP_RIGHT
                    })
                    return false
                }
                break;
        }

        if (adsetData?.length === 0) {
            toast.error('Please add at least one adset', { position: toast.POSITION.TOP_RIGHT });
            return false;
        }
        return true;
    }

    const saveFinalData = (value) => {
        switch (value?.channel?.adType) {
            case ADS_TYPE.META:
                return {
                    meta: {
                        objective: value?.objective && Object.keys(value?.objective).length > 0 ? value.objective.description : {},
                        buying_type: value?.buying_type && Object.keys(value?.buying_type).length > 0 ? value.buying_type.description : {},
                        bid_strategy: value?.bid_strategy && Object.keys(value?.bid_strategy).length > 0 ? value.bid_strategy.description : {},
                        spend_cap: value?.spend_cap ? parseFloat(value?.spend_cap) : 0,
                        daily_budget: value?.daily_budget ? parseFloat(value?.daily_budget) : 0,
                        special_ad_categories: value?.special_ad_categories && value?.special_ad_categories.length > 0 ? value.special_ad_categories.map((x) => { return x.description }) : [],
                    }
                }
            case ADS_TYPE.GOOGLE:
                return {
                    google: {
                        advertising_channel_type: value?.advertising_channel_type && Object.keys(value?.advertising_channel_type).length > 0 ? value.advertising_channel_type.description : null,
                        cpc_bid_micros: value?.cpc_bid_micros ? parseFloat(value?.cpc_bid_micros) : 0,
                        googleCampaignId: value?.googleCampaignId ?? null
                    }
                }
            case ADS_TYPE.LINKEDIN:
                return {
                    linkedin: {
                        type: value?.type && Object.keys(value?.type).length > 0 ? value.type.description : null,
                        dailyBudget: value?.dailyBudget ? parseFloat(value?.dailyBudget) : 0,
                    }
                }
        }
    }

    const saveCampaignAdsLink = async (campaignData) => {
        if (!campaignData?._id || !Array.isArray(campaignData?.ad_data)) return;

        for (const adData of campaignData.ad_data) {
            let linkCampaign = await API.getData(ENTITYNAME.SM_CampaignAdsLink, { query: [["campaign_id", "=", campaignData?._id], ["ad_id", "=", adData?.ad?._id]] }) ?? [];
            let linkCampaignId = linkCampaign?.data?.length > 0 ? linkCampaign?.data[0]?._id : null;
            await API.saveData(ENTITYNAME.SM_CampaignAdsLink, {
                _id: linkCampaignId,
                status: adData?.status ?? META_STATUS_TYPE.PAUSED,
                audience: adData?.audience,
                start_time: adData?.start_time,
                end_time: adData?.end_time,
                campaign_id: campaignData?._id,
                ad_id: adData?.ad?._id,
                dailyBudget: campaignData?.daily_budget ? parseFloat(campaignData?.daily_budget) : 0,
                meta: adData?.meta,
                google: adData?.google,
                linkedin: adData?.linkedin
            })
        }
    }

    const handleSubmit = async (e) => {
        if (!isValid()) return;
        const finalData = {
            _id: dataItem?._id,
            channel: dataItem?.channel && Object.keys(dataItem?.channel).length > 0 ? { _id: dataItem?.channel?._id, adType: dataItem?.channel?.adType } : {},
            budget: dataItem?.budget && Object.keys(dataItem?.budget).length > 0 ? { _id: dataItem?.budget?._id, description: dataItem?.budget?.description } : {},
            name: dataItem?.name ?? "",
            start_time: dataItem?.start_time ? utility.convertStringDatetoMilliseconds(dataItem?.start_time) : "",
            end_time: dataItem?.end_time ? utility.convertStringDatetoMilliseconds(dataItem?.end_time) : "",
            ...saveFinalData(dataItem),
        };
        console.log({ finalData })
        console.log(budgetCredit)
        let res = await API.saveData(ENTITYNAME.SM_Campaigns, finalData);
        if (res.success) {
            await saveCampaignAdsLink({ ...res?.data, ad_data: adsetData?.length > 0 ? adsetData : [], })
            utility.deleteLocalStorageItem(ENTITYNAME.SM_Campaigns);
            cancelEdit && cancelEdit();
            refresh && refresh();
        }
        else {
            toast.error(res.message, { position: toast.POSITION.TOP_RIGHT });
        }
    };

    const onPublishOrUnpublish = async (value = {}, isPublished = false) => {
        if (!dataItem?._id) {
            toast.error('Please save campaign first', { position: toast.POSITION.TOP_RIGHT });
            return;
        }
        setIsLoading(true);
        let res = await API.publishOrUnPublishCampaign({ campaign_id: dataItem?._id, ad_id: value?._id, isPublished });
        if (!res?.success) {
            toast.error(res?.message, { position: toast.POSITION.TOP_RIGHT });
            setIsLoading(false);
            return;
        }
        let updateData = adsetData.map(x => {
            if (x?._id === value?._id) {
                return {
                    ...x,
                    status: isPublished ? META_STATUS_TYPE.ACTIVE : META_STATUS_TYPE.PAUSED
                }
            }
            return x;
        })
        setAdsetData(updateData);
        toast.success(res?.message, { position: toast.POSITION.TOP_RIGHT });
        setIsLoading(false);
    }

    const handleAdsetEdit = (value = {}, index) => {
        setShowAdsetPopup({ show: true, item: { ...value, index } });
    }

    const smCampaignMenuModel = (props) => {
        const menu = [
            {
                label: 'Options',
                items: [
                    // {label: 'Delete',icon: 'pi pi-trash',command: () => ConfirmDeleteAlert(() => props.onDelete(props.dataIndex, props.dataItem), () => { })},
                    { label: 'Edit', icon: 'pi pi-pencil', command: () => props.onEdit(props.dataItem, props.dataIndex) },
                    { label: 'Publish', icon: 'pi pi-arrow-up', command: () => props.onPublish(props.dataItem, props.dataIndex, true) },
                    { label: 'Unpublish', icon: 'pi pi-arrow-down', command: () => props.onUnPublish(props.dataItem, props.dataIndex, false) }
                ]
            }
        ]
        return menu;
    }

    const MyCommandCell = (cell) => (
        <MenuCommandCell
            {...cell}
            // onDelete={onCampaignDelete}
            onEdit={handleAdsetEdit}
            onPublish={onPublishOrUnpublish}
            onUnPublish={onPublishOrUnpublish}
            myMenuModel={smCampaignMenuModel}
        />
    )

    const getDynamicKeys = () => {
        const dynamicKeys = new Set();
        adsetData.forEach(adset => {
            if (dataItem.channel?.adType === ADS_TYPE.META) {
                if (adset.ad) {
                    Object.keys(adset.ad).forEach(key => {
                        if (!['_id', 'SID', 'addOn', 'addBy', 'modOn', 'modBy', 'product', 'brand', 'creatives'].includes(key)) {
                            dynamicKeys.add(`ad.${key}`);
                        }
                    });
                }
                if (adset.meta) {
                    Object.keys(adset.meta).forEach(key => dynamicKeys.add(`meta.${key}`));
                }
            }
            else if (dataItem.channel?.adType === ADS_TYPE.GOOGLE) {
                if (adset.google) {
                    Object.keys(adset.google).forEach(key => dynamicKeys.add(`google.${key}`));
                }
            }
            else if (dataItem.channel?.adType === ADS_TYPE.LINKEDIN) {
                if (adset.linkedin) {
                    Object.keys(adset.linkedin).forEach(key => dynamicKeys.add(`linkedin.${key}`));
                }
            }
        });

        return dynamicKeys;
    }
    const dynamicKeys = getDynamicKeys();


    const onSelectBudget = () => {
        setOpenCampaignSelection(true)
    }

    const handleBudgetSelected = async (item) => {
        let budgetData = item?.length > 0 ? item[0] : {}
        setBudgetData(budgetData);
        setDataItem({ ...dataItem, budget: budgetData, start_time: moment(budgetData?.fromDate).format('YYYY-MM-DD HH:mm:ss'), end_time: moment(budgetData?.toDate).format('YYYY-MM-DD HH:mm:ss') });
        let res = await API.getAvailableBudget({ _id: budgetData?._id });
        if (res.success) setBudgetCredit(res.data)
    }

    const budgetHeaderStyle = { fontSize: "12px", fontWeight: "bold" };
    const budgetDetailValueStyle = { color: "blue", fontSize: "15px", padding: 0 };

    return (
        <BossDialog title={lang.campaign_dialog_header} onClose={cancelEdit} width={"800px"}>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <EditPageHeader showTitle={false} onSubmit={handleSubmit} onCancel={cancelEdit} />
                <div className="d-flex align-items-center" style={{ width: "218px" }}>
                    <div className="mr-2">{budgetData?.currency?.description} </div>
                    <div className="bg-green-100 text-green-800">{`Available Budget: ${budgetCredit?.remainingBudget ?? ""}`} </div>
                </div>
            </div>
            <div className='d-flex'>
                <div className='mr-auto'>
                    <label htmlFor="TabView">{lang.budget_label} *</label>
                    <div className='d-flex gap-2'>
                        <input name="Title" type="text" style={{ width: "320px" }} className="form-control form-control-sm mr-2" value={dataItem?.budget?.description} disabled={true} />
                        {!item?.budget?._id && <RoundButton icon="ellipsis-h" btnColor="success" style={{ color: "white", width: "30px", height: "30px" }} title={lang.select_button_text} name={"..."} onClick={onSelectBudget} />}
                    </div>
                </div>
                {dataItem?.budget?._id &&
                    <div className='d-flex mt-3'>
                        <div className="form-group marlr mb-0">
                            <label htmlFor="TabView" style={budgetHeaderStyle}>{lang.target_amount_label}</label><br />
                            <p style={budgetDetailValueStyle}>{budgetCredit?.targetAmount}</p>
                        </div>
                        <div className="form-group marlr mb-0">
                            <label htmlFor="TabView" style={budgetHeaderStyle}>{lang.start_date_label}</label><br />
                            <p style={budgetDetailValueStyle}>{moment(budgetCredit?.fromDate).format("DD-MM-YYYY")}</p>
                        </div>
                        <div className="form-group marlr mb-0">
                            <label htmlFor="TabView" style={budgetHeaderStyle}>{lang.end_Date_label}</label><br />
                            <p style={budgetDetailValueStyle}>{moment(budgetCredit?.toDate).format("DD-MM-YYYY")}</p>
                        </div>
                    </div>
                }
            </div>
            <div className='row'>
                <div className="col-6">
                    <div className="flex justify-between items-center"> <label htmlFor="name">{lang.name_label} *</label> </div>
                    <input
                        type="text"
                        name="name"
                        placeholder="Enter Name"
                        value={dataItem.name}
                        onChange={onChange}
                        className="form-control form-control-sm"
                    />
                </div>
                <div className="col-6">
                    <label htmlFor="channel">{lang.channel_label} *</label>
                    <DropDownList
                        name="channel"
                        textField="adType"
                        dataItemKey="_id"
                        data={channels}
                        value={dataItem.channel}
                        onChange={onChange}
                        style={{ backgroundColor: 'white' }}
                    />
                </div>
            </div>
            <div className='row mt-2'>
                <div className="col-6">
                    <div className="flex justify-between items-center"> <label htmlFor="start_time">{lang.start_time_label} *</label> </div>
                    <input
                        type="datetime-local"
                        id="start_time"
                        name="start_time"
                        value={dataItem.start_time}
                        onChange={onChange}
                        className="form-control form-control-sm"
                    />
                </div>
                <div className="col-6">
                    <div className="flex justify-between items-center"> <label htmlFor="end_time">{lang.end_time_label} *</label> </div>
                    <input
                        type="datetime-local"
                        id="end_time"
                        name="end_time"
                        value={dataItem.end_time}
                        onChange={onChange}
                        className="form-control form-control-sm"
                    />
                </div>
            </div>
            <div className='mt-2'>
                <div className="small text-secondary fw-bold"> {dataItem.channel?.adType ? utility.getKeyByValue(ADS_TYPE, dataItem.channel?.adType) : ""} </div>
                <div className="border border-secondary bg-white rounded shadow-sm p-2">
                    {dataItem.channel?.adType === ADS_TYPE.META &&
                        <MetaCampaignEditForm
                            dataItem={dataItem}
                            setDataItem={setDataItem}
                            minSpendCap={utility.convertCurrencyValue(dataItem?.budget?.currency?.description, 5000)}
                            budgetData={dataItem?.budget}
                        />
                    }
                    {dataItem.channel?.adType === ADS_TYPE.GOOGLE &&
                        <GoogleCampaignForm
                            dataItem={dataItem}
                            setDataItem={setDataItem}
                            minSpendCap={utility.convertCurrencyValue(dataItem?.budget?.currency?.description, 5000)}
                            budgetData={dataItem?.budget}
                        />
                    }
                    {dataItem.channel?.adType === ADS_TYPE.LINKEDIN &&
                        <LinkedinCampaignForm
                            dataItem={dataItem}
                            setDataItem={setDataItem}
                        />
                    }
                </div>
            </div>
            <div className='row mt-2'>
                <div className="col-12">
                    <div className='d-flex justify-content-between align-items-center'>
                        <AddRoundButton name="Create Adset" onClick={() => setShowAdsetPopup({ show: true, item: {} })} title="Create Adset" icon="plus" />
                        <div>Adsets({adsetData?.length ?? 0})</div>
                    </div>
                    <Grid resizable style={{ height: "27vh", marginTop: "5px" }} data={adsetData}>
                        <GridColumn cell={MyCommandCell} width={"50px"} />
                        <GridColumn field="ad_status" width="130px" title={lang.ad_status_column} cell={({ dataItem }) => <PublishOrUnPublishStatusCard dataItem={{ ...dataItem, ad_data: [dataItem] }} />} />
                        <GridColumn field='audience.name' title={lang.audience_column} width={"140px"} />
                        {[...dynamicKeys].map((key) => {
                            const title = key.split('.').slice(-1)[0].replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                            return (<GridColumn key={key} field={key} title={title} width="150px" />);
                        })}
                        <GridColumn field='start_time' width="180px" title={lang.start_time_column} cell={DateTimeCell} />
                        <GridColumn field='end_time' width="180px" title={lang.end_time_column} cell={DateTimeCell} />
                    </Grid>
                </div>
            </div>
            {showAdsetPopup.show && (
                <BossDialog title={showAdsetPopup.item?._id ? "Update Adset" : "Create Adset"} width={"80%"} onClose={() => setShowAdsetPopup({ show: false, item: {} })} >
                    <SMAdsetForm campaign={dataItem} item={showAdsetPopup.item} onCancel={() => setShowAdsetPopup({ show: false, item: {} })} onSave={handleAdsetCreate} channel={dataItem?.channel} />
                </BossDialog>
            )
            }
            {openCampaignSelection && <CollectionSelection addButtonTitle={lang.select_button_text} title={lang.budget_collection_header} entityname={ENTITYNAME.SM_Budgets} closeForm={() => setOpenCampaignSelection(!openCampaignSelection)} wherestatement={['Archive', '=', false]} setDataList={(dataList) => handleBudgetSelected(dataList)} mode={'single'} width={"50vw"} />}
        </BossDialog>
    )
}

export default SMCampaignCollectionForm;